module.exports = __webpack_public_path__ + "a4a1a41edd1322fc2c52045458e9e445.svg";